import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'creategroup',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			cityList: [],
			cityid: '',
			groupType: '',
			routeMode: '',
			groupName: '',
			selectedHub: '',
			selectedHubid: '',
			selectedHubname: '',
			fetchedHubs: [],
			templateList: [],
			groupName: "",
			groupNumber: '',
			searchFlag: false,
			validateFlag: false,
			citySearch: '',
			citySearchStatus: false,
			citySearchName: '',
			gpstatus: '',
			gptemplateid: '',
			gpCityId: '',
			changestatus: '',

			resultCount: 0,
			isLoading: false,
			groupStatusModal: false,
			allocateHubmodal: false,
			selectedGroupid: '',
			useremail: '',
			showHubListModal: '',
			hubStatusModal: false,
			changestatusHub: '',
			showHubListModal: false,
			mappedHUbsList: [],
			mappedHubCount: 0,
			mappedHUbID: 0,
			mappedGroupId: 0,

			cityObjData: {
				value: "",
				text: ""
			},
			groupTypeObjData: {
				value: "",
				text: ""
			},
			modeObjData: {
				value: "",
				text: ""
			},
			hubListObjData: {
				value: "",
				text: ""
			},
			citySearchObjData: {
				value: "",
				text: ""
			},
			groupTypeList: [{
					value: '1',
					text: "City"
				},
				{
					value: '2',
					text: "Rest Of City"
				},
				{
					value: '3',
					text: "RTO"
				}, {
					value: '4',
					text: "Rest of RTO"
				},
			],
			modeList: [{
					value: '1',
					text: "Surface"
				},
				{
					value: '2',
					text: "Air"
				},

			],
			pageCount: 0,
			pageNo: 0,
			limit: 10,
			totalRows: 0
		}
	},

	created: function() {},
	computed: {},

	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;

		this.getCityList();
		this.getAllHubs();

	},
	methods: {

		selectedCity(cityData) {
			//console.log(cityData);
			this.cityObjData = cityData;
			this.cityid = cityData.value;
			this.setGroupName();
		},
		selectedGroupType(groupData) {
			//console.log(cityData);
			this.groupTypeObjData = groupData;
			this.groupType = groupData.value;
			this.setGroupName();
		},
		selectedRouteMode(routeData) {
			//console.log(routeData);
			this.modeObjData = routeData;
			this.routeMode = routeData.text;
		},
		selectedHubName(hubData) {
			this.hubListObjData = hubData;
			this.selectedHubid = hubData.value;
			var splitVal = hubData.text.split(" ");
			this.selectedHubname = splitVal[0];
		},
		selectedCitySearch(searchCityData) {
			this.citySearchObjData = searchCityData;
			this.citySearch = searchCityData.value;
			this.citySearchName = searchCityData.text;
		},

		setGroupName() {
			if (this.cityid != "" && this.groupType != "") {
				if (this.groupType == 4) {
					this.groupName = 'Rest of ' + this.cityObjData.text + ' RTO';
				} else {
					this.groupName = this.groupTypeObjData.text + ' ' + this.cityObjData.text;
				}
			}
		},
		//to get target id in active/inactive modal
		getStatusRowData(data) {
			this.groupStatusModal = true;
			this.gptemplateid = data.groupid;
			this.gpstatus = data.isactive;
			this.gpCityId = data.cityid;
			if (data.isactive == true) {
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
		},
		closeStatusGroupModal() {
			this.groupStatusModal = false
		},
		changeGroupTemplateStatus() {
			this.isLoading = true;
			if (this.changestatus == 'De-Activate') {
				var newStatus = false;
			} else {
				var newStatus = true;
			}
			this.input = ({
				groupId: this.gptemplateid,
				cityId: this.gpCityId,
				isActive: newStatus,
				createdby: this.useremail,
			})

			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'deallocateGroup',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;
					if (result.data.ResultCode == 500) {
						//this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
					if (result.data.ResultCode == 101) {
						//  this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
					if (result.data.ResultCode == 100) {
						//this.$alertify.success('Template Status Changed Successfully')
						this.$alert('Template Status Changed Successfully', "", "success");
					}
					this.groupStatusModal = false;
					this.getGroupTemplates();
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		getGroupTemplates() {
			if (this.citySearch == null || this.citySearch == undefined || this.citySearch == '') {
				return false;
			}
			if (this.citySearch != "") {

				this.totalRows = 0
				this.resultCount = 0;
				this.searchFlag = true;
				this.templateList = [];
				this.input = ({})

				axios({
						method: 'GET',
						// legacy backup: getCityWiseGroups
						// 'url': apiUrl.api_url_hubops + 'getCityWiseGroups?offset=' + this.pageNo + '&limit=' + this.limit + '&cityId=' + this.citySearch + '&isActive=' + this.citySearchStatus,
						'url': apiUrl.api_url_hubops + 'groups?offset=' + this.pageNo + '&limit=' + this.limit + '&cityId=' + this.citySearch + '&isActive=' + this.citySearchStatus + '&includeTotalCount=true',
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							this.templateList = result.data.ResponseData
							this.resultCount = result.data.ResponseData.length
							this.totalRows = result.data.TotalCount
							if (this.totalRows < this.limit) {
								this.pageCount = 1
							} else {
								this.pageCount = Math.ceil(this.totalRows / this.limit);
							}
						} else {
							this.templateList = 0
							this.resultCount = 0
						}
					}, error => {
						console.error(error)
					})
			} else {
				//this.$alertify.error("Please Select Any City");
				this.$alert("Please Select Any City", "", "error");
				return false;
			}
		},
		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1)
			this.getGroupTemplates()
		},
		//to get City list
		getCityList() {
			this.isLoading = true;
			//var userToken = window.localStorage.getItem('userToken')
			//var myStr = userToken.replace(/"/g, '');
			var i = 0;
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'allcity/get',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.isLoading = false;
					var cityList = result.data.ResponseData
					for (i = 0; i < cityList.length; i++) {
						this.cityList.push({
							value: cityList[i].cityid,
							text: cityList[i].cityname
						})
					}
				}, error => {
					console.error(error)
				})
		},

		getAllHubs() {
			this.isLoading = true;
			var i = 0;
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.isLoading = false;
					var fetchedHubs = result.data.ResponseData
					for (i = 0; i < fetchedHubs.length; i++) {
						this.fetchedHubs.push({
							value: fetchedHubs[i].HubID,
							text: fetchedHubs[i].HubName + ' (' + fetchedHubs[i].HubID + ')'
						})
					}
				}, error => {
					console.error(error)
				})

		},
		//to Save Group Destination
		saveGroupTemplate() {
			this.$validator.validateAll().then((formResult) => {
				if (formResult == false) {
					return false;
				} else {
					this.isLoading = true;
					this.input = ({
						cityid: this.cityid,
						routemode: this.routeMode,
						grouptype: this.groupType,
						groupname: this.groupName,
						groupNo: this.groupNumber,
						createdby: this.useremail
					})
					axios({
							method: 'POST',
							'url': apiUrl.api_url_hubops + 'createGroupTemplate',
							'data': this.input,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',
							}
						})
						.then(result => {
							this.isLoading = false;
							if (result.data.ResultCode == 500) {
								//this.$alertify.error(result.data.ReturnMessage)
								this.$alert(result.data.ReturnMessage, "", "error");
							}
							if (result.data.ResultCode == 101) {
								//this.$alertify.error(result.data.ReturnMessage)
								this.$alert(result.data.ReturnMessage, "", "error");
							}
							if (result.data.ResultCode == 100) {
								//this.$alertify.success('Group Template Created Successfully')
								this.$alert('Group Template Created Successfully', "", "success");
							}
							this.resetForm();
						}, error => {
							console.error(error)
						})
				}
			})

		},

		getHubMappedListData(data) {
			this.isLoading = true;
			this.input = ({})
			axios({
					method: 'GET',
					// legacy backup: fetchGroupsAllocatedDestinationByGroupId
					// 'url': apiUrl.api_url_hubops + 'fetchGroupsAllocatedDestinationByGroupId?groupId=' + data.groupid,
					'url': apiUrl.api_url_hubops + 'groups?groupId=' + data.groupid + '&include=templateDestinations&responseShape=destinationsOnly',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.ResultCode == 500) {
						//this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
					if (result.data.ResultCode == 101) {
						//this.$alertify.error(result.data.ReturnMessage);
						this.$alert(result.data.ReturnMessage, "", "error");
						this.resultCountMappedHubs = 0;
						this.mappedHUbsList = [];
					}
					if (result.data.ResultCode == 100) {
						this.mappedHUbsList = result.data.ResponseData;
						this.mappedHubCount = result.data.ResponseData.length;
						this.showHubListModal = true;
					}

				}, error => {
					console.error(error)
				})
		},

		getStatusHublistData(data) {
			this.hubStatusModal = true;
			this.showHubListModal = false;
			this.mappedHUbID = data.destinationhubid;
			this.mappedGroupId = data.groupid;

			if (data.isactive == true) {
				this.changestatusHub = 'De-Activate'
			} else {
				this.changestatusHub = 'Activate'
			}
		},
		changeMappedHubStatus() {
			this.isLoading = true;
			if (this.changestatusHub == 'De-Activate') {
				var newStatus = false;
			} else {
				var newStatus = true;
			}
			this.input = ({
				groupId: this.mappedGroupId,
				destinationhubId: this.mappedHUbID,
				isActive: newStatus,
			})
			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'deAllocateGroupMapByHubId',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;
					if (result.data.ResultCode == 500) {
						//this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
					if (result.data.ResultCode == 101) {
						//this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
					if (result.data.ResultCode == 100) {
						//this.$alertify.success('Hub Status Changed Successfully')
						this.$alert('Hub Status Changed Successfully', "", "success");
					}
					this.showHubListModal = false;
					this.hubStatusModal = false;
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		openHubMapModal(data) {
			this.selectedGroupid = data.groupid;
			this.allocateHubmodal = true;
		},
		closeMapHubWithGroup() {
			this.allocateHubmodal = false;
			this.hubListObjData = {
				value: "",
				text: ""
			}
		},
		saveMapHubWithGroup() {
			if (this.selectedHubid != "") {
				this.isLoading = true;
				this.input = ({
					groupid: this.selectedGroupid,
					destinationhubid: this.selectedHubid,
					hubname: this.selectedHubname,
					createdby: this.useremail,

				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url_hubops + 'allocateHubToGroupTemplate',
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						this.isLoading = false;
						if (result.data.ResultCode == 500) {
							//this.$alertify.error(result.data.ReturnMessage)
							this.$alert(result.data.ReturnMessage, "", "error");
						}
						if (result.data.ResultCode == 101) {
							//this.$alertify.error(result.data.ReturnMessage)
							this.$alert(result.data.ReturnMessage, "", "error");
						}
						if (result.data.ResultCode == 100) {
							//this.$alertify.success('Hub Mapped To This Group')
							this.$alert('Hub Mapped To This Group', "", "success");
						}
						this.allocateHubmodal = false;
						this.hubListObjData = "";
					}, error => {
						console.error(error)
					})
			} else {
				//this.$alertify.error("Please Select Any HUb");
				this.$alert("Please Select Any HUb", "", "error");
				return false;
			}
		},

		closeStatusHubModal() {
			this.hubStatusModal = false;
		},
		closeshowHubListModal() {
			this.showHubListModal = false
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		//to reset search form
		resetForm() {

			this.routeMode = '';
			this.cityid = '';
			this.groupType = '';
			this.groupName = '';
			this.groupNumber = '';
			//document.getElementById("groupName").value = "";

			this.cityObjData = {
				value: "",
				text: ""
			};
			this.groupTypeObjData = {
				value: "",
				text: ""
			};
			this.modeObjData = {
				value: "",
				text: ""
			};
			//console.log(this.modeObjData);
			this.$validator.reset();

		},

		//validate all form fields on onsubmit()
		onSubmit: function(formname) {
			this.$validator.validateAll().then((formResult) => {
					if (formResult == false) {
						this.validateFlag = false
					} else {
						this.validateFlag = true;
						this.saveGroupDestination();
					}
					console.log('form is valid')
				})
				.catch(() => {
					console.log('errors exist')
				});
		},

		onSubmitSearch: function() {
			var self = this
			this.$validator.validateAll('form-1').then((result) => {
				if (!result) {
					return false;
				}
				// this.$alertify.success("your message");
			}).catch(() => {
				console.log('errors exist')
				//this.$alertify.error("your message")
			});
		},

	}
}


// WEBPACK FOOTER //
// ./src/views/components/group/creategroup/creategroup_component.js